import { FirestoreDocument } from '../../types';
import { parseFirestoreValue } from '../../utils';

/** Build a pretty-printed JSON string from a Firestore document. */
export function documentToJsonString(document: FirestoreDocument): string {
  const jsonData: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(document.data)) {
    jsonData[key] = parseFirestoreValue(value);
  }
  return JSON.stringify(jsonData, null, 2);
}

/** Ace editor theme name from dark-mode flag. */
export function getEditorTheme(isDark: boolean): 'monokai' | 'github' {
  return isDark ? 'monokai' : 'github';
}
